"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _Wrapper = _interopRequireDefault(require("./questions/questionMultipleButtons/Wrapper"));

var _ContestPicksSkeleton = _interopRequireDefault(require("./ContestPicksSkeleton"));

var _ContestPicksCheckboxes = _interopRequireDefault(require("./ContestPicksCheckboxes"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (props) {
  return props.needsPaddingTop && "padding-top: 2rem;";
});

var StyledBlock = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0 3rem 2rem;\n  border-top: 2px solid ", ";\n  background: white;\n  margin-bottom: 4rem;\n"])), function (props) {
  return props.theme.colorBorder;
});

var StyledNumber = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  min-height: 60px;\n  margin: 0 auto;\n  font-weight: 700;\n  border-radius: 50%;\n  border: 5px solid\n    ", ";\n  background: ", ";\n  color: ", ";\n  transform: translateY(-50%);\n"])), function (props) {
  return process.env.REACT_APP_BACKGROUND_IMAGE ? "white" : props.theme.colorContentBackground;
}, function (props) {
  return props.theme.colorAccent;
}, function (props) {
  return props.theme.colorAccentText;
});

var height = "3rem";
var lightGrey = "#f7f8fa";

var StyledHeader = _styledComponents.default.header(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: flex-start;\n  max-height: ", ";\n  height: ", ";\n  color: ", ";\n"])), height, height, function (p) {
  return p.theme.colorPrimaryText;
});

var StyledTriangle = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -", ";\n  right: -", ";\n  border: ", " solid transparent;\n  border-left: ", " solid transparent;\n  border-right: ", " solid transparent;\n  border-bottom: ", " solid ", ";\n  width: calc(", " * 2);\n"])), height, height, height, height, height, height, function (p) {
  return lightGrey;
}, height);

var StyledContent = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  height: ", ";\n  padding: 0 1.5rem 0 1.25rem;\n  color: ", ";\n  background: ", ";\n"])), height, function (p) {
  return p.theme.colorLabel;
}, function (p) {
  return lightGrey;
});

var StyledContentTitle = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  align-self: stretch;\n  display: grid;\n  place-items: center;\n  position: relative;\n  z-index: 2;\n  font-size: 1rem;\n"])));

var StyledContentSubtitle = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n"])));

var StyledGameBannerWrapper = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: 1rem 1rem 0;\n"])));

var StyledPicksBannerWrapper = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin: -2rem 1rem 3rem;\n"])));

var ContestPicks = function ContestPicks(_ref) {
  var translations = _ref.translations,
      app = _ref.app,
      betbarParent = _ref.betbarParent,
      updatePicks = _ref.updatePicks,
      isLocked = _ref.isLocked,
      hidePopularPick = _ref.hidePopularPick,
      GameBanner = _ref.GameBanner,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      hasCheckboxes = _ref.hasCheckboxes,
      consentCheckboxes = _ref.consentCheckboxes,
      setConsetCheckboxes = _ref.setConsetCheckboxes,
      onTermsAndConditionsClicked = _ref.onTermsAndConditionsClicked,
      hasQuestionStatBelowQuestion = _ref.hasQuestionStatBelowQuestion;
  // const { showAffiliateBanners } = useSelector((s) => s.app);
  var activePickem = betbarParent.activePickem,
      activeBet = betbarParent.activeBet,
      hadBet = betbarParent.hadBet;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      picks = _useSelector.picks;

  var questions = activePickem === null || activePickem === void 0 ? void 0 : activePickem.questions;
  var selections = activeBet === null || activeBet === void 0 ? void 0 : activeBet.selections;
  var indexesToShowBanner = [2];

  if (process.env.REACT_APP_AFFILIATE_BANNER_INDEXES) {
    indexesToShowBanner = process.env.REACT_APP_AFFILIATE_BANNER_INDEXES.split(",").map(function (i) {
      return +i;
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    id: "voorspelling",
    needsPaddingTop: process.env.REACT_APP_HIDE_CONTEST_BANNER,
    children: !questions ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestPicksSkeleton.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [questions.map(function (_ref2, index) {
        var _options$find;

        var id = _ref2.id,
            label = _ref2.label,
            subtitle = _ref2.subtitle,
            options = _ref2.options,
            data = _ref2.data,
            availablePoints = _ref2.availablePoints,
            popularSelection = _ref2.popularSelection,
            status = _ref2.status,
            tips = _ref2.tips;
        var showIcon = status.indexOf("IN_PLAY") > -1 || status.indexOf("COMPLETE") > -1;
        var correctAnswerId = !hadBet || !options.some(function (obj) {
          return obj.points;
        }) ? -1 : options.find(function (obj) {
          return obj.points > 0;
        }).id;
        var myAnswerId = picks === null || picks === void 0 ? void 0 : picks[id];
        var popularSelectionString = "";
        var popularSelectionLabel = (_options$find = options.find(function (obj) {
          return obj.id === (popularSelection === null || popularSelection === void 0 ? void 0 : popularSelection.optionId);
        })) === null || _options$find === void 0 ? void 0 : _options$find.label;

        if (popularSelection && popularSelectionLabel) {
          popularSelectionString = "".concat(popularSelectionLabel, " - ").concat(popularSelection.percentage, "%");
        } else {
          popularSelectionString = "N/A";
        }

        var tipsterString = "";

        if (tips && tips[0]) {
          tipsterString = options.find(function (obj) {
            return obj.id === tips[0].option.id;
          }).label;
        }

        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [indexesToShowBanner.includes(index) && (questions === null || questions === void 0 ? void 0 : questions.length) > 0 && activeBet && (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED" && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPicksBannerWrapper, {
            children: GameBanner
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Card, {
            style: {
              padding: "0 1rem 1rem",
              marginBottom: index === questions.length - 1 ? 0 : "3rem"
            },
            children: [questions && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNumber, {
              children: index + 1
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Wrapper.default, {
              isLocked: isLocked,
              hidePopularPick: hidePopularPick,
              translations: translations,
              updatePicks: updatePicks,
              betbarParent: betbarParent,
              data: data,
              availablePoints: availablePoints,
              myAnswerId: myAnswerId,
              correctAnswerId: correctAnswerId,
              popularSelectionString: popularSelectionString,
              hasQuestionStatBelowQuestion: hasQuestionStatBelowQuestion,
              tips: tips,
              showIcon: showIcon,
              id: id,
              options: options,
              label: label,
              subtitle: subtitle,
              tipsterString: tipsterString,
              isUsingAlternativeImages: isUsingAlternativeImages
            })]
          }, id)]
        });
      }), hasCheckboxes && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContestPicksCheckboxes.default, {
        tenantDetails: app.tenantDetails,
        dataSharePermissions: app.dataSharePermissions,
        isDisabled: activeBet,
        consentCheckboxes: consentCheckboxes,
        setConsetCheckboxes: setConsetCheckboxes,
        translations: translations,
        onTermsAndConditionsClicked: onTermsAndConditionsClicked
      }), (questions === null || questions === void 0 ? void 0 : questions.length) > 0 && activeBet && (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED" && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledGameBannerWrapper, {
        children: GameBanner
      })]
    })
  });
};

var _default = ContestPicks;
exports.default = _default;